<template>
    <dashboard>
        <row>
            <panel>
                <h3 slot="title">Users</h3>
                <template slot="buttons">
                    <app-button size="small" @click="showAddUser = true">Add User</app-button>
                </template>

                <user-table
                    :items="users"
                    :sort-by="sort_by"
                    :columns="['first_name','last_name','email']"
                    @sort-change="sortChange">
                    <template slot="actions">
                        <el-table-column label="Actions" width="150px" align="right">
                            <template slot-scope="scope">
                                <app-tooltip effect="dark" content="Remove From Team" placement="top-end">
                                    <app-button
                                        type="danger"
                                        size="mini"
                                        icon="icon-delete"
                                        @click.stop="handleRemove(scope.$index, scope.row)">
                                        <span class="visuallyhidden">Remove User From Team</span>
                                    </app-button>
                                </app-tooltip>
                            </template>
                        </el-table-column>
                    </template>
                </user-table>
            </panel>
        </row>

        <modal v-model="showAddUser">
            <team-add-user :team_id="team.id" @reload="getUsers(getParameters())" />
        </modal>
    </dashboard>
</template>

<script>
import table from '@/mixins/table'
import User from '@/store/models/User'

import UserTable from '../User/UserTable'
import TeamAddUser from './TeamAddUser'

export default {
    name: 'page-team-detail-users',
    components: {
        UserTable,
        TeamAddUser
    },
    mixins: [table],
    props: ['uuid', 'team'],
    data() {
        return {
            users: [],
            total: 0,
            showAddUser: false,
            relation: 'assignedTeams',
            tableParamKeys: ['relation', 'relation_uuid']
        }
    },
    computed: {
        relation_uuid() {
            return this.uuid
        }
    },
    mounted() {
        this.getUsers(this.getParameters())
    },
    methods: {
        getUsers(params) {
            User.$fetchAll(params)
                .then(({ data, raw }) => {
                    this.users = data
                    this.total = raw.total
                })
        },
        navigateToStudentDetail(student) {
            this.$router.push({
                name: 'students.detail',
                params: { uuid: student.uuid }
            })
        },
        paramsChanged(params) {
            this.getStudents(params)
        },
        handleRemove(index, user) {
            this.$confirm({
                title: 'Confirm',
                message: 'Are you sure you want to remove this user?'
            })
                .then(() => {
                    return user.$detach(this.team.id, 'assignedTeams', 'removeUserFromTeam')
                })
                .then(() => {
                    return this.getUsers(this.getParameters())
                })
                .then(() => {
                    this.$notify({
                        title: 'Success',
                        message: 'The user has been removed from the team.',
                        type: 'success',
                        offset: 75,
                        duration: 2000
                    })
                })
        },
        stateChange(state) {
            let params = this.getParameters()
            params.state = state
            this.setParameters(params)
        }
    }
}
</script>

<style lang="stylus"></style>
